import { PROD, BETA } from '../../constants/environment';

/**
 * Creates a chart engine css path for the given product and environment
 * and used on publish when writing inset, html and iframe.
 * @param {string} product
 * @return {string} a string that represents a css path and formatted as wsj-digital.1.dev.css | wsj-digital.1.css
 */
function getChartCssPath(product, isVideo = false) {
  return `${product}-${isVideo ? 'video' : 'digital'}.${window.CHART_CSS_VERSION}${
    window.ENVIRONMENT !== PROD && window.ENVIRONMENT !== BETA ? `.dev` : ''
  }.css`;
}

export { getChartCssPath };
